<template>
  <!-- 修改密码 -->
  <div class="selSchool">
    <van-nav-bar title="" @click-left="btnleft" fixed>
      <template #left>
        <img
          class="return_class"
          :src="require('@/assets/img/returnPng.png')"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="al_bind">
      <div class="al_title">重置密码</div>
      <div class="al_notice">备注：密码由8-20个英文字母、数字及符号组成</div>
      <div class="al_content">
        <van-form ref="remakeref" @submit="save">
          <div class="al_wrap_box isRecessary">
            <van-field
              v-model="oldPwd"
              input-align="right"
              name="原密码"
              label="原密码"
              type="password"
              @focus="fucus=true"
              @blur="fucus=false"
              :placeholder="noticeOld"
              clearable
              maxlength="20"
              :rules="[{ required: true, message: '' }, { validator }]"
            />
          </div>
          <div class="al_wrap_box isRecessary">
            <van-field
              clearable
              @focus="fucus=true"
              @blur="fucus=false"
              v-model="newPwd"
              input-align="right"
              name="新的密码"
              type="password"
              label="新的密码"
              maxlength="20"
              :placeholder="noticeNew"
              :rules="[
                { required: true, message: '' },
                { validator: validator1 },
              ]"
            />
          </div>
          <div class="al_wrap_box isRecessary">
            <van-field
              clearable
              @focus="fucus=true"
              @blur="fucus=false"
              v-model="confirmPwd"
              input-align="right"
              name="确认密码"
              type="password"
              label="确认密码"
              maxlength="20"
              :placeholder="noticeCon"
              :rules="[
                { required: true, message: '' },
                { validator: validator2 },
              ]"
            />
          </div>
        </van-form>
      </div>
      <div :class="fucus ? 'marClass' : 'addArea'">
        <div class="btnBox">
          <van-button block @click="onSubmit" class="btn" type="info">
            确定
            <img class="blueSha" src="../../assets/img/blueshadow.png" alt="" />
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { judgeVde } from "@/utils/publicJudge";
import { setToken, getCookie, getUser } from "@/utils/common";
import { Toast, Dialog, Notify } from "vant";
var crypto = require("crypto");
export default {
  data() {
    return {
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
      vde: "",
      fucus: false,
      noticeOld: "请输入原密码",
      noticeNew: "请输入新的密码",
      noticeCon: "请再次确认新密码",
      alreadyToast: false,
      keyId: "",
      publicKey: "",
    };
  },

  created() {
    this.vde = this.$route.query.vde ? this.$route.query.vde : "";
    judgeVde({ vde: this.vde }, this);
    this.initKey();
  },
  methods: {
    // 加密key
    initKey() {
      this.request({
        url: "/sso/initKey",
        method: "get",
      }).then((res) => {
        if (res.data.code === 1000) {
          this.keyId = res.data.result.keyId;
          this.publicKey = res.data.result.publicKey;
        }
      });
    },
    encrypt(publicKey, data) {
      //使用公钥加密
      let publicKeyStr =
        "-----BEGIN PUBLIC KEY-----\n" +
        publicKey +
        "\n" +
        "-----END PUBLIC KEY-----";

      let encryptStr = crypto.publicEncrypt(
        { key: publicKeyStr, padding: crypto.constants.RSA_PKCS1_PADDING },
        Buffer.from(data, "utf8")
      );
      let encrypted = encryptStr.toString("base64");
      return encrypted;
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      let flag =
        /^(?=.{8,20})(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/.test(
          val
        );
      if (val.length > 20) {
        flag = false;
      }
      if (val.length < 8) {
        flag = false;
      }
      if (!flag && !this.alreadyToast) {
        this.alreadyToast = true;
        // this.noticeOld='原密码格式不正确';
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "原密码格式不正确",
        }).then((res) => {
          this.alreadyToast = false;
        });
      }
      return flag;
    },
    validator1(val) {
      let flag =
        /^(?=.{8,20})(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/.test(
          val
        );
      if (val.length > 20) {
        flag = false;
      }
      if (val.length < 8) {
        flag = false;
      }
      if (!flag && !this.alreadyToast) {
        this.alreadyToast = true;

        // this.noticeOld='新密码格式不正确';
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "新密码格式不正确",
        }).then((res) => {
          this.alreadyToast = false;
        });
      }
      return flag;
    },
    validator2(val) {
      let flag =
        /^(?=.{8,20})(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/.test(
          val
        );
      if (val.length > 20) {
        flag = false;
      }
      if (val.length < 8) {
        flag = false;
      }

      if (!flag && !this.alreadyToast) {
        this.alreadyToast = true;

        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "确认密码格式不正确",
        }).then((res) => {
          this.alreadyToast = false;
        });
      }
      return flag;
    },
    onSubmit() {
      this.$refs.remakeref.submit();
    },
    save() {
      this.request({
        url: "/user/savePwd",
        method: "post",
        params: {
          oldpwd:this.encrypt(this.publicKey, this.oldPwd) ,
          rpwd: this.encrypt(this.publicKey, this.newPwd) ,
          reRpwd:  this.encrypt(this.publicKey, this.confirmPwd),
          publicKey: this.publicKey,
          keyId: this.keyId,
        },
      }).then((res) => {
        if (res && res.data.code == 1000) {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {
            Toast.loading({
              message: "退出中...",
              forbidClick: true,
            });
            let data = {
              token: getCookie("token"),
            };
            this.request({
              url: "/sso/logout",
              method: "post",
              data: data,
            }).then((res) => {
              setTimeout(() => {
                setToken("");
                Toast.clear();
                localStorage.setItem('checkSuc','1');
                Notify({ type: "success", message: "退出成功" });
                this.$router.push({
                  path:
                    "/login?vde=" +
                    localStorage.getItem("vde") +
                    "&fromtype=" +
                    localStorage.getItem("loginFromType"),
                });
              }, 1000);
            });
          });
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {});
        }
      });
    },
    btnleft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.return_class {
  width: 18px;
}
.selSchool {
  height: 100vh;
  position: relative;
  padding-top:46px;
  background: #fff;
  box-sizing: border-box;
  ::v-deep .van-hairline--bottom::after {
    border-bottom: none;
  }
  ::v-deep .van-nav-bar__title {
    font-family: PingFangSC-Semibold;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
  }
  ::v-deep .van-nav-bar .van-icon {
    color: #666;
  }
}
.al_bind {
  // padding-top: 46px;
  box-sizing: border-box;
  width: 305px;
  margin: 0 auto;
  margin-top: 20px;
  .btnBox {
    // margin-top: 50px;
    ::v-deep .van-button--info {
      border: none !important;
      outline: none !important;
    }
    .btn {
      margin: 0 auto;
      width: 305px;
      background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
      border-radius: 22px;

      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      z-index: 15;
      position: relative;
      margin-top: 50px;
      .blueSha {
        z-index: 10;
        width: 266px;
        height: 34px;
        position: absolute;
        left: 50%;
        top: 68%;
        transform: translateX(-50%);
      }
    }
  }
  .addArea {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 48px;
    // padding-top: calc(20vh);
  }
  .marClass{
    margin-top: 60vh;
  }
  .al_title {

    font-size: 22px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  .al_notice {

    font-size: 14px;
    color: #7d8081;
    letter-spacing: 0;
    font-weight: 500;
    margin-top: 14px;
    margin-bottom: 30px;
  }
  .al_wrap_box {
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    margin-bottom: 20px;
    ::v-deep .van-cell {
      border-radius: 4px;
      border-bottom: none !important;
    }
    ::v-deep .van-field__label {

      font-size: 16px;
      color: #7d8081;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: 400;
      margin-right: 0px !important;
    }
    ::v-deep .van-field__control {

      font-size: 16px;
      letter-spacing: 0;
      text-align: right;
      font-weight: 400;
    }
  }
  .al_wrap_box.isRecessary > .van-field:before {
    position: absolute;
    left: 0.21333rem;
    color: #ee0a24;
    font-size: 0.37333rem;
    content: "*";
    top: 10px;
  }
}
</style>
